import { useEffect } from 'react';

const BASE_TITLE = 'HaulSync';

/**
 * Sets document.title to "pageTitle | HaulSync" while the component is mounted.
 * Pass no argument (or empty string) for the base "HaulSync" title.
 *
 * Usage:
 *   usePageTitle('About Us');  // → "About Us | HaulSync"
 *   usePageTitle();            // → "HaulSync"
 */
export function usePageTitle(pageTitle) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} | ${BASE_TITLE}` : BASE_TITLE;
  }, [pageTitle]);
}
